'use client';

import { useState, useRef, useEffect } from 'react';

// ── Chat effect definitions ──────────────────────────────
const EFFECTS = [
  { cmd: 'big', demo: 'LETS GOOOO', desc: 'Pulses larger and returns.' },
  { cmd: 'small', demo: 'oh no...', desc: 'Shrinks down like a whisper.' },
  { cmd: 'shake', demo: "nah that ain't it", desc: 'Disapproving head-shake.' },
  { cmd: 'nod', demo: 'facts', desc: 'Agreeing up-and-down bob.' },
  { cmd: 'explode', demo: 'BOOOOM', desc: 'Blows up toward the viewer.' },
  { cmd: 'ripple', demo: 'the wave is here', desc: 'Letters rise in a stadium wave.' },
  { cmd: 'bloom', demo: 'absolutely stunning', desc: 'Bold sweep left to right.' },
  { cmd: 'jitter', demo: "I'M SO MAD", desc: 'Rapid angry vibration.' },
];

// ── Sound effect definitions (80 built-in sounds) ────────
const SOUNDS = [
  { cmd: 'airhorn', name: 'Air Horn', cat: 'alerts' },
  { cmd: 'bamp', name: 'Bamp', cat: 'alerts' },
  { cmd: 'bang', name: 'Bang', cat: 'alerts' },
  { cmd: 'ding', name: 'Ding', cat: 'alerts' },

  { cmd: 'brick', name: 'Brick', cat: 'comedy' },
  { cmd: 'cantdoit', name: "Can't Do It", cat: 'comedy' },
  { cmd: 'comoestan', name: 'Como Estan', cat: 'comedy' },
  { cmd: 'douche', name: 'Douche', cat: 'comedy' },
  { cmd: 'everytime', name: 'Every Time', cat: 'comedy' },
  { cmd: 'fail', name: 'Fail', cat: 'comedy' },
  { cmd: 'failhorn', name: 'Fail Horn', cat: 'comedy' },
  { cmd: 'hedead', name: 'He Dead', cat: 'comedy' },
  { cmd: 'inahole', name: 'In A Hole', cat: 'comedy' },
  { cmd: 'insandouts', name: 'Ins and Outs', cat: 'comedy' },
  { cmd: 'junk', name: 'Junk', cat: 'comedy' },
  { cmd: 'kick', name: 'Kick', cat: 'comedy' },
  { cmd: 'laststraw', name: 'Last Straw', cat: 'comedy' },
  { cmd: 'mlum', name: 'Mlum', cat: 'comedy' },
  { cmd: 'nonsense', name: 'Nonsense', cat: 'comedy' },
  { cmd: 'punch', name: 'Punch', cat: 'comedy' },
  { cmd: 'scream', name: 'Scream', cat: 'comedy' },
  { cmd: 'stepoff', name: 'Step Off', cat: 'comedy' },
  { cmd: 'stomp', name: 'Stomp', cat: 'comedy' },
  { cmd: 'throw', name: 'Throw', cat: 'comedy' },
  { cmd: 'vomit', name: 'Vomit', cat: 'comedy' },
  { cmd: 'yousaidit', name: 'You Said It', cat: 'comedy' },
  { cmd: 'zachlaugh', name: 'Zach Laugh', cat: 'comedy' },

  { cmd: 'coin', name: 'Coin', cat: 'gaming' },
  { cmd: 'dbzpowerup', name: 'DBZ Power Up', cat: 'gaming' },
  { cmd: 'dronedown', name: 'Drone Down', cat: 'gaming' },
  { cmd: 'flagpole', name: 'Flagpole', cat: 'gaming' },
  { cmd: 'gameover', name: 'Game Over', cat: 'gaming' },
  { cmd: 'heatingup', name: 'Heating Up', cat: 'gaming' },
  { cmd: 'kamehameha', name: 'Kamehameha', cat: 'gaming' },
  { cmd: 'mariodead', name: 'Mario Dead', cat: 'gaming' },
  { cmd: 'onfire', name: 'On Fire', cat: 'gaming' },
  { cmd: 'powerup', name: 'Power Up', cat: 'gaming' },
  { cmd: 'teleport', name: 'Teleport', cat: 'gaming' },
  { cmd: 'wasted', name: 'Wasted', cat: 'gaming' },
  { cmd: 'youlose', name: 'You Lose', cat: 'gaming' },

  { cmd: 'apparently', name: 'Apparently', cat: 'memes' },
  { cmd: 'benson', name: 'Benson', cat: 'memes' },
  { cmd: 'cops', name: 'Cops', cat: 'memes' },
  { cmd: 'davidpumpkins', name: 'David Pumpkins', cat: 'memes' },
  { cmd: 'doit', name: 'Do It', cat: 'memes' },
  { cmd: 'donny1', name: 'Donny', cat: 'memes' },
  { cmd: 'escalated', name: 'Escalated', cat: 'memes' },
  { cmd: 'gotchabitch', name: 'Gotcha', cat: 'memes' },
  { cmd: 'goteem', name: 'Got Eem', cat: 'memes' },
  { cmd: 'highground', name: 'High Ground', cat: 'memes' },
  { cmd: 'lookatthis', name: 'Look At This', cat: 'memes' },
  { cmd: 'michaelno', name: 'Michael No', cat: 'memes' },
  { cmd: 'mmkay', name: "M'kay", cat: 'memes' },
  { cmd: 'phrasing', name: 'Phrasing', cat: 'memes' },
  { cmd: 'profamity', name: 'Profamity', cat: 'memes' },
  { cmd: 'scooby', name: 'Scooby', cat: 'memes' },
  { cmd: 'shooter', name: 'Shooter', cat: 'memes' },
  { cmd: 'wizard', name: 'Wizard', cat: 'memes' },
  { cmd: 'ytmnd', name: 'YTMND', cat: 'memes' },

  { cmd: 'cantstop', name: "Can't Stop", cat: 'music' },
  { cmd: 'downtown', name: 'Downtown', cat: 'music' },
  { cmd: 'hbo', name: 'HBO', cat: 'music' },
  { cmd: 'jeopardy', name: 'Jeopardy', cat: 'music' },
  { cmd: 'spybreak', name: 'Spybreak', cat: 'music' },

  { cmd: 'audience', name: 'Audience', cat: 'reactions' },
  { cmd: 'awwjeez', name: 'Aww Jeez', cat: 'reactions' },
  { cmd: 'bruh', name: 'Bruh', cat: 'reactions' },
  { cmd: 'clap', name: 'Clap', cat: 'reactions' },
  { cmd: 'damn', name: 'Damn', cat: 'reactions' },
  { cmd: 'easy', name: 'Easy', cat: 'reactions' },
  { cmd: 'godly', name: 'Godly', cat: 'reactions' },
  { cmd: 'hello', name: 'Hello', cat: 'reactions' },
  { cmd: 'impressed', name: 'Impressed', cat: 'reactions' },
  { cmd: 'myman', name: 'My Man', cat: 'reactions' },
  { cmd: 'nonono', name: 'No No No', cat: 'reactions' },
  { cmd: 'oof', name: 'Oof', cat: 'reactions' },
  { cmd: 'perfect', name: 'Perfect', cat: 'reactions' },
  { cmd: 'realize', name: 'Realize', cat: 'reactions' },
  { cmd: 'respect', name: 'Respect', cat: 'reactions' },
  { cmd: 'yeahbaby', name: 'Yeah Baby', cat: 'reactions' },
];

const CATEGORIES = [
  { id: 'all', label: 'All' },
  { id: 'alerts', label: 'Alerts' },
  { id: 'comedy', label: 'Comedy' },
  { id: 'gaming', label: 'Gaming' },
  { id: 'memes', label: 'Memes' },
  { id: 'music', label: 'Music' },
  { id: 'reactions', label: 'Reactions' },
];

// Split letters into spans with stagger delays for ripple/bloom effects
function wrapLetters(text) {
  let idx = 0;
  return text.split('').map((ch, i) => {
    if (ch === ' ') return <span key={i}> </span>;
    const delay = idx * 0.06;
    idx++;
    return (
      <span key={i} style={{ '--char-delay': `${delay}s` }}>
        {ch}
      </span>
    );
  });
}

export default function CommandsClient() {
  const [activeCat, setActiveCat] = useState('all');
  const [playingCmd, setPlayingCmd] = useState(null);
  const audioRef = useRef(null);
  const playTimeoutRef = useRef(null);
  const effectRefs = useRef({});

  // Clean up audio + timeouts on unmount
  useEffect(() => {
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
      }
      if (playTimeoutRef.current) clearTimeout(playTimeoutRef.current);
    };
  }, []);

  function replayEffect(cmd) {
    const el = effectRefs.current[cmd];
    if (!el) return;
    const fx = `fx-${cmd}`;
    el.classList.remove(fx);
    // Force a reflow so the animation restarts cleanly
    void el.offsetWidth;
    el.classList.add(fx);
  }

  function playSound(cmd) {
    if (audioRef.current) {
      audioRef.current.pause();
    }
    if (playTimeoutRef.current) clearTimeout(playTimeoutRef.current);

    setPlayingCmd(cmd);
    const audio = new Audio(`/sounds/builtin/${cmd}.mp3`);
    audioRef.current = audio;
    audio.play().catch(() => {
      // Missing file / autoplay blocked — visual-only feedback is fine
    });
    const clearPlaying = () => setPlayingCmd((current) => (current === cmd ? null : current));
    audio.addEventListener('ended', clearPlaying);
    // Safety fallback: clear the playing state after 5s even if 'ended' never fires
    playTimeoutRef.current = setTimeout(clearPlaying, 5000);
  }

  const soundsByCat = (cat) => (cat === 'all' ? SOUNDS.length : SOUNDS.filter((s) => s.cat === cat).length);

  return (
    <div className="commands-root">
      {/* ── Hero ───────────────────────────────────── */}
      <header className="hero">
        <div className="container">
          <img className="hero-brand" src="/logo/shoosh-messy-crop.png" alt="Shoosh" />
          <h1>
            Chat <span className="accent">Commands</span>
          </h1>
          <p>
            Everything you can type in chat to make things happen on stream. Sounds, animated text, and TTS controls —
            all universal.
          </p>
        </div>
      </header>

      {/* ── Sticky nav ─────────────────────────────── */}
      <nav className="quicknav">
        <div className="nav-inner">
          <a href="#effects">Text Effects</a>
          <a href="#sounds">Sound Effects</a>
          <a href="#tts">TTS Control</a>
          <a href="#mods">Mod Commands</a>
        </div>
      </nav>

      <div className="container">
        {/* ── Callout ─────────────────────────────── */}
        <div className="callout">
          <div className="dot" />
          <p>
            <strong>Heads up:</strong>
            {
              ' Streamers can disable or restrict any of these, add cooldowns, or upload their own custom sounds. If a command doesn’t work, your streamer may have it disabled.'
            }
          </p>
        </div>

        {/* ── Text Effects ────────────────────────── */}
        <section id="effects">
          <div className="section-head">
            <span className="eyebrow">Animated text</span>
            <h2>Text Effects</h2>
            <p>
              Type one of these at the start of your message to animate how it appears in the stream overlay. The text
              still gets read out, but with a little extra flair.
            </p>
          </div>

          <div className="effects-grid">
            {EFFECTS.map((e) => {
              const isCharEffect = e.cmd === 'ripple' || e.cmd === 'bloom';
              return (
                <div
                  key={e.cmd}
                  className={`effect-card fx-${e.cmd}`}
                  ref={(el) => {
                    effectRefs.current[e.cmd] = el;
                  }}
                  onClick={() => replayEffect(e.cmd)}
                >
                  <span className="replay-hint">Click to replay</span>
                  <div className="cmd">!{e.cmd}</div>
                  <div className="demo">
                    <span className="msg-text">{isCharEffect ? wrapLetters(e.demo) : e.demo}</span>
                  </div>
                  <div className="desc">{e.desc}</div>
                </div>
              );
            })}
          </div>
        </section>

        {/* ── Sound Effects ───────────────────────── */}
        <section id="sounds">
          <div className="section-head">
            <span className="eyebrow">80 sounds ready to play</span>
            <h2>Sound Effects</h2>
            <p>
              {
                'Type any of these commands in chat to play a sound on stream. Click a pill here to preview it. There’s a short cooldown between sounds to keep chat from spamming.'
              }
            </p>
          </div>

          <div className="category-tabs">
            {CATEGORIES.map((c) => (
              <button
                key={c.id}
                className={`category-tab${activeCat === c.id ? ' active' : ''}`}
                onClick={() => setActiveCat(c.id)}
              >
                {c.label}
                <span className="count">{soundsByCat(c.id)}</span>
              </button>
            ))}
          </div>

          <div className="sounds-grid">
            {SOUNDS.map((s) => {
              const hidden = activeCat !== 'all' && s.cat !== activeCat;
              const isPlaying = playingCmd === s.cmd;
              return (
                <div
                  key={s.cmd}
                  className={`sound-pill${hidden ? ' hidden' : ''}${isPlaying ? ' playing' : ''}`}
                  onClick={() => playSound(s.cmd)}
                >
                  <span className="cmd">!{s.cmd}</span>
                  <span className="name">{s.name}</span>
                </div>
              );
            })}
          </div>
        </section>

        {/* ── TTS Control ─────────────────────────── */}
        <section id="tts">
          <div className="section-head">
            <span className="eyebrow">Make the bot read you (or not)</span>
            <h2>TTS Control</h2>
            <p>
              Depending on how the streamer has TTS set up, you might need to use one of these prefixes to get your
              message read aloud — or to skip TTS for a single message.
            </p>
          </div>

          <div className="tts-cards">
            <div className="tts-card">
              <span className="cmd">!tts &lt;message&gt;</span>
              <h3>Command Mode</h3>
              <p>
                Only messages that start with <code>!tts</code> get read aloud. The <code>!tts</code> prefix is stripped
                from the audio.
              </p>
              <div className="example">
                e.g. <code>!tts hello everyone</code> → reads “hello everyone”
              </div>
            </div>

            <div className="tts-card">
              <span className="cmd">!shh &lt;message&gt;</span>
              <h3>Skip TTS (Opt-Out)</h3>
              <p>
                {
                  'Your message still shows in chat but doesn’t get read out. Useful for links, inside jokes, or stuff you don’t want spoken.'
                }
              </p>
              <div className="example">
                e.g. <code>!shh brb for a sec</code> → shows in chat, silent
              </div>
            </div>

            <div className="tts-card">
              <span className="cmd">@streamer &lt;message&gt;</span>
              <h3>Mention Mode</h3>
              <p>
                When the streamer has Mention mode on, only messages that <code>@</code>-mention them get read. The
                mention itself is stripped from the audio.
              </p>
              <div className="example">
                e.g. <code>@shoosh how’s it going</code> → reads “how’s it going”
              </div>
            </div>

            <div className="tts-card">
              <span className="cmd">@question &lt;your question&gt;</span>
              <h3>Ask a Question</h3>
              <p>
                {
                  'When the streamer has the Question Queue on, your message gets held for them to read when they’re ready — not played immediately. You’ll see a 🤔 acknowledgment in chat so you know it landed.'
                }
              </p>
              <div className="example">
                e.g. <code>@question what’s your favorite song?</code> → held until the streamer reads it
              </div>
            </div>
          </div>
        </section>

        {/* ── Mod Commands ────────────────────────── */}
        <section id="mods">
          <div className="section-head">
            <span className="eyebrow">Moderator tools</span>
            <h2>Mod Commands</h2>
            <p>{'If you’re a moderator for the stream, you have a few extra commands to keep TTS clean.'}</p>
          </div>

          <div className="mod-section">
            <div className="mod-header">
              <span className="mod-badge">Mods only</span>
              <h3>Keep TTS under control</h3>
            </div>
            <p>
              These commands only work for moderators, broadcasters, and channel owners. They start with{' '}
              <code className="inline-code">#</code> instead of <code className="inline-code">!</code> so they won’t
              accidentally fire as sounds.
            </p>

            <div className="mod-commands">
              <div className="mod-cmd">
                <span className="cmd">#tts-mute &lt;username&gt;</span>
                <span className="desc">Stops TTS from reading that user’s messages. They can still chat normally.</span>
              </div>
              <div className="mod-cmd">
                <span className="cmd">#tts-unmute &lt;username&gt;</span>
                <span className="desc">Brings a muted user back into the TTS rotation.</span>
              </div>
              <div className="mod-cmd">
                <span className="cmd">#tts-skip</span>
                <span className="desc">Skips whatever TTS is currently playing.</span>
              </div>
              <div className="mod-cmd">
                <span className="cmd">#tts-clear</span>
                <span className="desc">Empties the entire TTS queue immediately.</span>
              </div>
            </div>
          </div>
        </section>

        {/* ── Bits / Gifts note ───────────────────── */}
        <section id="bits">
          <div className="section-head">
            <span className="eyebrow">Automatic</span>
            <h2>Bits, Super Chats &amp; Gifts</h2>
            <p>
              Twitch Bits, YouTube Super Chats, and TikTok Gifts automatically trigger overlay effects on stream — no
              command needed. Bigger amounts get bigger reactions.
            </p>
          </div>
        </section>
      </div>

      {/* ── Footer ─────────────────────────────────── */}
      <footer>
        <div className="container">
          <div className="brand">Shoosh</div>
          <p>TTS for streamers that stops when they talk.</p>
        </div>
      </footer>

      {/* ── Styles (global so body background overrides layout) ─ */}
      <style jsx global>{`
        :root {
          --cmd-bg: #0e0e10;
          --cmd-bg-card: #18181c;
          --cmd-bg-card-hover: #1d1d22;
          --cmd-border: #2a2a30;
          --cmd-border-strong: #3a3a42;
          --cmd-pink: #ff90e8;
          --cmd-pink-dim: rgba(255, 144, 232, 0.12);
          --cmd-text: #fff;
          --cmd-text-dim: #a0a0a8;
          --cmd-text-muted: #66666e;
          --cmd-mod-yellow: #f5c518;
        }

        body:has(.commands-root) {
          background: var(--cmd-bg) !important;
          color: var(--cmd-text);
        }

        .commands-root {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          line-height: 1.5;
          min-height: 100vh;
        }
        .commands-root * {
          box-sizing: border-box;
        }
        .commands-root .container {
          max-width: 1100px;
          margin: 0 auto;
          padding: 0 24px;
        }

        /* ── Hero ─────────────────────────────── */
        .commands-root .hero {
          padding: 80px 0 56px;
          text-align: center;
          position: relative;
        }
        .commands-root .hero-brand {
          display: block;
          margin: 0 auto 28px;
          height: 72px;
          width: auto;
          filter: drop-shadow(0 4px 20px rgba(255, 144, 232, 0.25));
        }
        @media (min-width: 768px) {
          .commands-root .hero-brand {
            height: 96px;
          }
        }
        .commands-root .hero h1 {
          font-size: clamp(40px, 7vw, 72px);
          font-weight: 900;
          letter-spacing: -0.02em;
          line-height: 1;
          margin-bottom: 20px;
          color: var(--cmd-text);
        }
        .commands-root .hero h1 .accent {
          color: var(--cmd-pink);
        }
        .commands-root .hero p {
          font-size: 18px;
          color: var(--cmd-text-dim);
          max-width: 560px;
          margin: 0 auto;
        }

        /* ── Sticky nav ───────────────────────── */
        .commands-root nav.quicknav {
          position: sticky;
          top: 0;
          z-index: 50;
          background: rgba(14, 14, 16, 0.92);
          backdrop-filter: blur(12px);
          -webkit-backdrop-filter: blur(12px);
          border-bottom: 1px solid var(--cmd-border);
          margin-bottom: 56px;
        }
        .commands-root nav.quicknav .nav-inner {
          max-width: 1100px;
          margin: 0 auto;
          padding: 16px 24px;
          display: flex;
          gap: 8px;
          overflow-x: auto;
          scrollbar-width: none;
        }
        .commands-root nav.quicknav .nav-inner::-webkit-scrollbar {
          display: none;
        }
        .commands-root nav.quicknav a {
          flex-shrink: 0;
          padding: 8px 16px;
          border-radius: 999px;
          border: 2px solid var(--cmd-border);
          background: transparent;
          color: var(--cmd-text);
          font-weight: 700;
          font-size: 13px;
          text-decoration: none;
          transition: all 0.15s;
          white-space: nowrap;
        }
        .commands-root nav.quicknav a:hover {
          border-color: var(--cmd-pink);
          background: var(--cmd-pink-dim);
        }

        /* ── Sections ─────────────────────────── */
        .commands-root section {
          padding-bottom: 96px;
          scroll-margin-top: 80px;
        }
        .commands-root .section-head {
          margin-bottom: 32px;
        }
        .commands-root .section-head .eyebrow {
          display: inline-block;
          font-size: 11px;
          font-weight: 900;
          letter-spacing: 2px;
          color: var(--cmd-pink);
          text-transform: uppercase;
          margin-bottom: 10px;
        }
        .commands-root .section-head h2 {
          font-size: clamp(28px, 4vw, 40px);
          font-weight: 900;
          letter-spacing: -0.01em;
          line-height: 1.1;
          margin-bottom: 8px;
          color: var(--cmd-text);
        }
        .commands-root .section-head p {
          font-size: 15px;
          color: var(--cmd-text-dim);
          max-width: 640px;
        }

        /* ── Text Effects Grid ────────────────── */
        .commands-root .effects-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
          gap: 16px;
        }
        .commands-root .effect-card {
          background: var(--cmd-bg-card);
          border: 2px solid var(--cmd-border);
          border-radius: 14px;
          padding: 20px;
          cursor: pointer;
          transition:
            background 0.2s,
            border-color 0.2s,
            transform 0.2s;
          position: relative;
          overflow: hidden;
        }
        .commands-root .effect-card:hover {
          background: var(--cmd-bg-card-hover);
          border-color: var(--cmd-pink);
          transform: translateY(-2px);
        }
        .commands-root .effect-card .cmd {
          display: inline-block;
          font-family: 'SF Mono', Menlo, Consolas, monospace;
          font-size: 13px;
          font-weight: 800;
          color: var(--cmd-pink);
          background: var(--cmd-pink-dim);
          padding: 4px 10px;
          border-radius: 6px;
          margin-bottom: 14px;
        }
        .commands-root .effect-card .demo {
          font-size: 22px;
          font-weight: 800;
          min-height: 42px;
          margin-bottom: 14px;
          line-height: 1.2;
          overflow: hidden;
          color: var(--cmd-text);
        }
        .commands-root .effect-card .demo .msg-text {
          display: inline-block;
        }
        .commands-root .effect-card .desc {
          font-size: 13px;
          color: var(--cmd-text-dim);
        }
        .commands-root .effect-card .replay-hint {
          position: absolute;
          top: 14px;
          right: 14px;
          font-size: 10px;
          font-weight: 700;
          color: var(--cmd-text-muted);
          text-transform: uppercase;
          letter-spacing: 1px;
          opacity: 0;
          transition: opacity 0.15s;
        }
        .commands-root .effect-card:hover .replay-hint {
          opacity: 1;
        }

        /* ── Effect animations ────────────────── */
        @keyframes cmdFxBig {
          0%,
          100% {
            transform: scale(1);
          }
          15% {
            transform: scale(1.3);
          }
          30% {
            transform: scale(1);
          }
        }
        .commands-root .fx-big .msg-text {
          animation: cmdFxBig 3s ease-in-out infinite;
          transform-origin: left center;
        }

        @keyframes cmdFxSmall {
          0%,
          100% {
            transform: scale(1);
            opacity: 1;
          }
          15% {
            transform: scale(0.7);
            opacity: 0.75;
          }
          30% {
            transform: scale(1);
            opacity: 1;
          }
        }
        .commands-root .fx-small .msg-text {
          animation: cmdFxSmall 3s ease-in-out infinite;
          transform-origin: left center;
        }

        @keyframes cmdFxShake {
          0%,
          100% {
            transform: translateX(0);
          }
          10% {
            transform: translateX(-6px);
          }
          20% {
            transform: translateX(6px);
          }
          30% {
            transform: translateX(-6px);
          }
          40% {
            transform: translateX(6px);
          }
          50% {
            transform: translateX(-5px);
          }
          60% {
            transform: translateX(5px);
          }
          70% {
            transform: translateX(-3px);
          }
          80% {
            transform: translateX(3px);
          }
          90% {
            transform: translateX(0);
          }
        }
        .commands-root .fx-shake .msg-text {
          animation: cmdFxShake 1.2s ease-in-out infinite;
        }

        @keyframes cmdFxNod {
          0%,
          100% {
            transform: translateY(0);
          }
          20% {
            transform: translateY(-6px);
          }
          40% {
            transform: translateY(2px);
          }
          60% {
            transform: translateY(-4px);
          }
          80% {
            transform: translateY(1px);
          }
        }
        .commands-root .fx-nod .msg-text {
          animation: cmdFxNod 1s ease-in-out infinite;
        }

        @keyframes cmdFxExplode {
          0% {
            transform: scale(1);
            opacity: 1;
            filter: brightness(1);
          }
          30% {
            transform: scale(1.8);
            opacity: 1;
            filter: brightness(1.5);
          }
          60% {
            transform: scale(2.2);
            opacity: 0.4;
            filter: brightness(2);
          }
          80% {
            transform: scale(2.5);
            opacity: 0;
            filter: brightness(3);
          }
          82% {
            transform: scale(0.5);
            opacity: 0;
          }
          100% {
            transform: scale(1);
            opacity: 1;
            filter: brightness(1);
          }
        }
        .commands-root .fx-explode .msg-text {
          animation: cmdFxExplode 3s cubic-bezier(0.16, 1, 0.3, 1) infinite;
          transform-origin: center center;
        }

        .commands-root .fx-ripple .msg-text span {
          display: inline-block;
          animation: cmdFxRippleChar 1.5s ease-in-out infinite;
          animation-delay: var(--char-delay);
        }
        @keyframes cmdFxRippleChar {
          0%,
          40%,
          100% {
            transform: translateY(0);
          }
          20% {
            transform: translateY(-8px);
          }
        }

        .commands-root .fx-bloom .msg-text span {
          display: inline-block;
          animation: cmdFxBloomChar 2s ease-in-out infinite;
          animation-delay: var(--char-delay);
        }
        @keyframes cmdFxBloomChar {
          0%,
          30%,
          100% {
            font-weight: 400;
            transform: scaleX(1);
          }
          15% {
            font-weight: 900;
            transform: scaleX(1.15);
            color: var(--cmd-pink);
          }
        }

        @keyframes cmdFxJitter {
          0% {
            transform: translate(0, 0);
          }
          10% {
            transform: translate(-2px, 1px);
          }
          20% {
            transform: translate(2px, -2px);
          }
          30% {
            transform: translate(-1px, 2px);
          }
          40% {
            transform: translate(2px, 1px);
          }
          50% {
            transform: translate(-2px, -1px);
          }
          60% {
            transform: translate(1px, 2px);
          }
          70% {
            transform: translate(-1px, -2px);
          }
          80% {
            transform: translate(2px, -1px);
          }
          90% {
            transform: translate(-2px, 1px);
          }
          100% {
            transform: translate(0, 0);
          }
        }
        .commands-root .fx-jitter .msg-text {
          animation: cmdFxJitter 0.3s linear infinite;
        }

        /* ── Sound Effects ────────────────────── */
        .commands-root .category-tabs {
          display: flex;
          gap: 8px;
          margin-bottom: 24px;
          flex-wrap: wrap;
        }
        .commands-root .category-tab {
          padding: 8px 16px;
          border-radius: 999px;
          border: 2px solid var(--cmd-border);
          background: transparent;
          color: var(--cmd-text);
          font-weight: 700;
          font-size: 13px;
          cursor: pointer;
          transition: all 0.15s;
          font-family: inherit;
        }
        .commands-root .category-tab:hover {
          border-color: var(--cmd-border-strong);
        }
        .commands-root .category-tab.active {
          border-color: var(--cmd-pink);
          background: var(--cmd-pink);
          color: #000;
        }
        .commands-root .category-tab .count {
          display: inline-block;
          margin-left: 6px;
          font-size: 11px;
          opacity: 0.7;
        }

        .commands-root .sounds-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
          gap: 10px;
        }
        .commands-root .sound-pill {
          background: var(--cmd-bg-card);
          border: 2px solid var(--cmd-border);
          border-radius: 10px;
          padding: 12px 14px;
          cursor: pointer;
          transition: all 0.15s;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 8px;
          user-select: none;
        }
        .commands-root .sound-pill:hover {
          background: var(--cmd-bg-card-hover);
          border-color: var(--cmd-pink);
        }
        .commands-root .sound-pill.playing {
          border-color: var(--cmd-pink);
          background: var(--cmd-pink-dim);
          box-shadow: 0 0 20px rgba(255, 144, 232, 0.3);
        }
        .commands-root .sound-pill .cmd {
          font-family: 'SF Mono', Menlo, Consolas, monospace;
          font-size: 13px;
          font-weight: 800;
          color: var(--cmd-pink);
        }
        .commands-root .sound-pill .name {
          font-size: 11px;
          color: var(--cmd-text-muted);
          text-transform: uppercase;
          letter-spacing: 0.5px;
          font-weight: 700;
        }
        .commands-root .sound-pill.hidden {
          display: none;
        }

        /* ── TTS Control ──────────────────────── */
        /* 2×2 grid at any width above the mobile breakpoint so 4 cards
           lay out symmetrically. auto-fit would put 3 across on wide
           viewports and orphan the 4th. The @media block below drops to
           a single column on phones. */
        .commands-root .tts-cards {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 16px;
        }
        .commands-root .tts-card {
          background: var(--cmd-bg-card);
          border: 2px solid var(--cmd-border);
          border-radius: 14px;
          padding: 24px;
        }
        .commands-root .tts-card .cmd {
          display: inline-block;
          font-family: 'SF Mono', Menlo, Consolas, monospace;
          font-size: 15px;
          font-weight: 800;
          color: var(--cmd-pink);
          background: var(--cmd-pink-dim);
          padding: 6px 12px;
          border-radius: 6px;
          margin-bottom: 14px;
        }
        .commands-root .tts-card h3 {
          font-size: 18px;
          font-weight: 800;
          margin-bottom: 8px;
          color: var(--cmd-text);
        }
        .commands-root .tts-card p {
          font-size: 13px;
          color: var(--cmd-text-dim);
        }
        .commands-root .tts-card .example {
          margin-top: 14px;
          padding-top: 14px;
          border-top: 1px solid var(--cmd-border);
          font-size: 13px;
          color: var(--cmd-text-muted);
          font-style: italic;
        }
        .commands-root .tts-card .example code {
          color: var(--cmd-text);
          background: var(--cmd-bg);
          padding: 2px 6px;
          border-radius: 4px;
          font-family: 'SF Mono', Menlo, Consolas, monospace;
          font-style: normal;
          font-size: 12px;
        }
        .commands-root .tts-card p code {
          color: var(--cmd-text);
          background: var(--cmd-bg);
          padding: 2px 6px;
          border-radius: 4px;
          font-family: 'SF Mono', Menlo, Consolas, monospace;
          font-size: 12px;
        }

        /* ── Mod Commands ─────────────────────── */
        .commands-root .mod-section {
          background: var(--cmd-bg-card);
          border: 2px solid var(--cmd-border);
          border-left: 4px solid var(--cmd-mod-yellow);
          border-radius: 14px;
          padding: 32px;
        }
        .commands-root .mod-section .mod-header {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 20px;
        }
        .commands-root .mod-badge {
          display: inline-block;
          font-size: 10px;
          font-weight: 900;
          letter-spacing: 1.5px;
          color: #000;
          background: var(--cmd-mod-yellow);
          padding: 4px 10px;
          border-radius: 4px;
          text-transform: uppercase;
        }
        .commands-root .mod-section h3 {
          font-size: 20px;
          font-weight: 900;
          color: var(--cmd-text);
        }
        .commands-root .mod-section > p {
          font-size: 13px;
          color: var(--cmd-text-dim);
          margin-bottom: 24px;
        }
        .commands-root .mod-section .inline-code {
          color: var(--cmd-mod-yellow);
          background: var(--cmd-bg);
          padding: 2px 6px;
          border-radius: 4px;
          font-family: 'SF Mono', Menlo, Consolas, monospace;
          font-size: 12px;
        }
        .commands-root .mod-commands {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
          gap: 12px;
        }
        .commands-root .mod-cmd {
          padding: 14px;
          background: var(--cmd-bg);
          border: 1px solid var(--cmd-border);
          border-radius: 8px;
        }
        .commands-root .mod-cmd .cmd {
          display: block;
          font-family: 'SF Mono', Menlo, Consolas, monospace;
          font-size: 13px;
          font-weight: 800;
          color: var(--cmd-mod-yellow);
          margin-bottom: 6px;
        }
        .commands-root .mod-cmd .desc {
          font-size: 12px;
          color: var(--cmd-text-dim);
        }

        /* ── Callout ──────────────────────────── */
        .commands-root .callout {
          background: var(--cmd-pink-dim);
          border: 2px solid var(--cmd-pink);
          border-radius: 14px;
          padding: 20px 24px;
          margin-bottom: 48px;
          display: flex;
          align-items: center;
          gap: 16px;
        }
        .commands-root .callout .dot {
          flex-shrink: 0;
          width: 10px;
          height: 10px;
          background: var(--cmd-pink);
          border-radius: 50%;
          box-shadow: 0 0 14px var(--cmd-pink);
          animation: cmdPulse 2s infinite;
        }
        @keyframes cmdPulse {
          0%,
          100% {
            opacity: 1;
            transform: scale(1);
          }
          50% {
            opacity: 0.6;
            transform: scale(0.85);
          }
        }
        .commands-root .callout p {
          font-size: 13px;
          color: var(--cmd-text);
        }
        .commands-root .callout strong {
          color: var(--cmd-pink);
          font-weight: 800;
        }

        /* ── Footer ───────────────────────────── */
        .commands-root footer {
          padding: 56px 0 40px;
          text-align: center;
          border-top: 1px solid var(--cmd-border);
          margin-top: 40px;
        }
        .commands-root footer .brand {
          font-size: 20px;
          font-weight: 900;
          color: var(--cmd-pink);
          letter-spacing: -0.01em;
          margin-bottom: 8px;
        }
        .commands-root footer p {
          font-size: 13px;
          color: var(--cmd-text-muted);
        }

        /* ── Responsive ───────────────────────── */
        @media (max-width: 640px) {
          .commands-root .hero {
            padding: 56px 0 40px;
          }
          .commands-root section {
            padding-bottom: 64px;
          }
          .commands-root nav.quicknav .nav-inner {
            padding: 12px 16px;
          }
          .commands-root .mod-section {
            padding: 24px;
          }
          .commands-root .tts-cards {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </div>
  );
}
